var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.72 6.934a.601.601 0 0 0-.603-.08l-9.63 4.066c-.419.177-.943.263-1.48.263-.751.002-1.528-.168-2.07-.4a2.49 2.49 0 0 1-.469-.253c.042-.02.09-.04.146-.062l8.76-3.697 1.308.545V5.722a.741.741 0 0 0-.28-.594.6.6 0 0 0-.602-.08L9.16 9.112c-.297.118-.552.26-.768.47a1.28 1.28 0 0 0-.393.908c0 .01.003.026.003.026v14.32L8 24.854l.002.012v.015h.002c.021.507.28.83.527 1.044.778.67 2.084 1.044 3.473 1.074.658 0 1.326-.102 1.943-.356l9.632-4.07c.255-.102.42-.373.42-.67V7.53a.753.753 0 0 0-.28-.596z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.4444b60ffa3e3b4d6897a376c677275f.svg";
export { ForwardRef as ReactComponent };